import Api, { handleData, handleError } from '../Api';
import request from '../request';

import { url } from './config';
import { User } from './types';

class ExtendedUsersApi extends Api<User> {
    saveSignature(userId: string | number, signatureData: string | null) {
        return request.put('/settings-save-signature', { _id: userId, signatureData }).then(handleData).catch(handleError);
    }
}

const api = new ExtendedUsersApi(url);

export default api;
